import { makeStyles } from '@material-ui/core';
import { Pricing, Product } from '@nemuru-eng/js-api-client';

import { TableColumn } from '../../../../../../../config/types';

export const usePricingSpecsTable = (pricing: Pricing) => {
  const useStyles = makeStyles({
    root: {
      '& .MuiTableCell-root': {
        paddingInline: 6,
        paddingBlock: 8,
        '&:first-child': {
          paddingLeft: 0,
        },
      },
      '& .MuiTableRow-head': {
        verticalAlign: 'bottom',
      },
      '&. MuiButton-sizeSmall': {
        paddingInline: 2,
        minWidth: 10,
      },
    },
    label: {
      margin: '4px',
      '& .MuiChip-labelSmall': {
        paddingLeft: '2px',
        paddingRight: '4px',
      },
    },
  });

  const classes = useStyles();

  const columnsDesktop: TableColumn[] = [
    { name: 'rangePrincipal', label: 'RANGE_PRINCIPAL', align: 'left', colWidth: '240px' },
    { name: 'rangePeriod', label: 'RANGE_PERIOD', align: 'left', colWidth: '80px' },
    { name: 'annualInterest', label: 'ANNUAL_INTEREST', align: 'left', colWidth: '80px' },
    { name: 'setupFee', label: 'EXPENSES', align: 'left', colWidth: '140px' },
    { name: 'merchantDiscountPercentage', label: 'COST_MERCHANT', align: 'left', colWidth: '140px' },
    { name: 'merchantFee', label: 'MERCHANT_FEE', align: 'left', colWidth: '100px' },
    { name: 'gracePeriod', label: 'GRACE_PERCENTAGE_PERIOD', align: 'left', colWidth: '140px' },
    { name: 'paymentMethodType', label: 'PAYMENT_METHOD_TYPE', align: 'left', colWidth: '120px' },
    { name: 'lenderPricingName', label: 'LENDER_PRICING_NAME', align: 'left' },
    ...(pricing.product === Product.AUTO
      ? ([
          { name: 'insurance', label: 'INSURANCES', align: 'left' },
          { name: 'registration', label: 'YEARS_SINCE_REGISTRATION', align: 'left' },
        ] as TableColumn[])
      : []),
    { name: 'moreActions', label: '', align: 'center' },
  ];

  return { classes, columns: columnsDesktop };
};
